<template>
  <div>
    <br />
    <!-- Selector de usuario centrado arriba -->
    <div class="text-center mb-3">
      <label for="usuarioSeleccionado" class="me-2">
        <strong
        >Seleccionar
          {{
          p_tipo === "med" ? "Médico Auditor" : "Gestor Documental"
          }}:</strong
        >
      </label>
      <select
              v-model="usuarioSeleccionado"
              id="usuarioSeleccionado"
              class="form-select w-auto d-inline-block"
      >
        <option
                v-for="usuario in usuarios"
                :key="usuario.idUsuario"
                :value="usuario.idUsuario"
        >
          {{ usuario.personaNombre }}
        </option>
      </select>
    </div>

    <table class="table table-striped" id="sampleTable">
      <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col">
          {{ p_tipo === "med" ? "Médico Auditor" : "Gestor Documental" }}
        </th>
        <th scope="col">Fecha desde</th>
        <th scope="col">Fecha hasta</th>
        <th scope="col" class="text-right">Registros</th>
        <th scope="col" v-if="botones"></th>
        <th scope="col" v-if="p_idPerfil == 17 && botones"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="carga in datosPaginados" :key="carga.idCarga">
        <td>
            <span
                    class="material-icons"
                    style="font-size: 24px; color: blue; cursor: pointer"
                    @click="
                abrirModalEditar(
                  carga.idCarga,
                  carga.fechaDesde,
                  carga.fechaHasta
                )
              "
                    :title="
                detalleSemanaTitle(
                  getFormattedDate(carga.fechaDesde, 'DD/MM/YYYY'),
                  getFormattedDate(carga.fechaHasta, 'DD/MM/YYYY')
                )
              "
            >
              info
            </span>
        </td>
        <td>{{ p_tipo === "med" ? carga.nombreMed : carga.nombreDoc }}</td>
        <td>{{ getFormattedDate(carga.fechaDesde, "DD/MM/YYYY") }}</td>
        <td>{{ getFormattedDate(carga.fechaHasta, "DD/MM/YYYY") }}</td>
        <td class="text-right">{{ carga.numeroRegVal }}</td>
        <td>
          <button
                  @click="actualizarUsuario(carga.idCarga, this.p_tipo)"
                  class="btn btn-success"
          >
            Asignar/Reasignar
            {{ p_tipo === "med" ? "Médico Auditor" : "Gestor Documental" }}
          </button>
        </td>
<td>
  <button
    @click="abrirNovedades(carga.idTramite, carga.idCarga)"
  >
    <span
      class="material-symbols-outlined"
      style="font-size: 24px; color: red; cursor: pointer"
      title="Reporte de novedades de carga"
    >
      picture_as_pdf
    </span>
  </button>
</td>
<td>
  <button
    v-if="botones"
    @click="p_tipo === 'med' ? obsAuditoriaMedicaSemanaPDF(carga.idCarga) : obsGestionDocumentalSemanaPDF(carga.idCarga)"
  >
    <span
      class="material-symbols-outlined"
      style="font-size: 24px; color: red; cursor: pointer"
      title="Reporte de observaciones"
    >
      picture_as_pdf
    </span>
  </button>
</td>
        <td>
          <button
                  @click="enviarObservaciones(p_tipo === 'med' ? 1 : 2)"
                  v-if="p_idPerfil == 17 && botones"
          >
                <span
                  class="material-symbols-outlined"
                  title="Enviar reporte de observaciones"
                >
                     forward_to_inbox
                </span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" @click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
                v-for="pagina in totalPaginas()"
                :key="pagina"
                @click="getDataPagina(pagina)"
                class="page-item"
                :class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" @click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
            class="modal fade"
            id="ventanaModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size: 24px; color: white"
            >info</span
            >
            <h5 class="modal-title" id="exampleModalLabel">{{ titulo }}</h5>
            <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Información General -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="fw-bold text-primary">Información General</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque01">
                    {{
                    mostrarBloque01
                    ? "(-) Menos información"
                    : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <hr />
              <div v-if="mostrarBloque01" class="mb-3">
                <div class="mb-4">
                  <div class="row mb-3" v-if="btnEditar">
                    <div class="col-1">
                      <label class="form-label fw-bold">IdCarga</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.idCarga }}</span>
                    </div>
                    <div class="col-1">
                      <label class="form-label fw-bold">IdTramite</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.idTramite }}</span>
                    </div>
                    <div class="col-1">
                      <label class="form-label fw-bold">IdSemana</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.idSemana }}</span>
                    </div>
                    <div class="col-1">
                      <label class="form-label fw-bold">Estado</label>
                    </div>
                    <div class="col-2">
                      <span>{{
                        datoCarga.estado === 1 ? "Activa" : "Inactiva"
                      }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Observación</label>
                    </div>
                    <div class="col-10">
                      <span>{{ datoCarga.obs }}</span>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <!-- Usuarios Asociados -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="fw-bold text-primary">Usuarios Asociados</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque02">
                    {{
                    mostrarBloque02
                    ? "(-) Menos información"
                    : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <hr />
              <div v-if="mostrarBloque02" class="mb-3">
                <div class="mb-4">
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Prestador</label>
                    </div>
                    <div class="col-8">
                      <span
                      >{{ datoCarga.usuarioReg }}
                        {{ datoCarga.nombreReg }}</span
                      >
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaIniCarga)
                      }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Supervisor AM</label>
                    </div>
                    <div class="col-8">
                      <span
                      >{{ datoCarga.usuarioSupMed || "N/A" }}
                        {{ datoCarga.nombreSupMed || "N/A" }}</span
                      >
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaAsigAud)
                      }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Médico</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.usuarioMed || "N/A" }}</span>
                    </div>
                    <div class="col-4">
                      <span>{{ datoCarga.nombreMed || "N/A" }}</span>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaIniAud) }}</span>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaFinAud) }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Supervisor GD</label>
                    </div>
                    <div class="col-8">
                      <span
                      >{{ datoCarga.usuarioSupDoc || "N/A" }}
                        {{ datoCarga.nombreSupDoc || "N/A" }}</span
                      >
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaAsigDoc)
                      }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Documentador</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.usuarioDoc || "N/A" }}</span>
                    </div>
                    <div class="col-4">
                      <span>{{ datoCarga.nombreDoc || "N/A" }}</span>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaIniDoc) }}</span>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaFinDoc) }}</span>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <!-- Fechas -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="fw-bold text-primary">Fechas</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque03">
                    {{
                    mostrarBloque03
                    ? "(-) Menos información"
                    : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <hr />
              <div v-if="mostrarBloque03" class="mb-3">
                <div class="mb-4">
                  <div class="row mb-3">
                    <div class="col-3">
                      <label class="form-label fw-bold"
                      >Fecha Registro Trámite:</label
                      >
                    </div>
                    <div class="col-9">
                      <span>{{
                        getFormattedDate(datoCarga.tramiteFechaReg)
                      }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-4">
                      <label class="form-label fw-bold text-info"
                      >Periodo de atenciones:</label
                      >
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Desde</label>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaDesde) }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Hasta</label>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaHasta) }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-4">
                      <label class="form-label fw-bold text-info">Carga:</label>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Inicio</label>
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaIniCarga)
                      }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Fin</label>
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaFinCarga)
                      }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-4">
                      <label class="form-label fw-bold text-info"
                      >Archivo:</label
                      >
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Creación</label>
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaCreacion)
                      }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold"
                      >Fecha Actualización</label
                      >
                    </div>
                    <div class="col-2">
                      <span>{{
                        getFormattedDate(datoCarga.fechaActualizacion)
                      }}</span>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <!-- Información del Archivo -->
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="fw-bold text-primary">Archivo Cargado</h5>
                <div>
                  <button @click.prevent="mostrarOcultarBloque04">
                    {{
                    mostrarBloque04
                    ? "(-) Menos información"
                    : "(+) Más información"
                    }}
                  </button>
                </div>
              </div>
              <hr />
              <div v-if="mostrarBloque04" class="mb-3">
                <div class="mb-4">
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Nombre Archivo</label>
                    </div>
                    <div class="col-10">
                      <span>{{ datoCarga.nombreArchivo }}</span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2">
                      <label class="form-label fw-bold">Tamaño (bytes)</label>
                    </div>
                    <div class="col-4">
                      <span>{{ datoCarga.tamanioArchivo }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold"
                      >Número de Registros</label
                      >
                    </div>
                    <div class="col-4">
                      <span>{{ datoCarga.numeroRegistros }}</span>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import config from '@/config';
  import api from "@/services/api";
  import dateFormat from "@/modules/dateFormat.js";

  import Swal from "sweetalert2";
  import * as $ from "jquery";
  window["$"] = $;

  export default {
    props: {
      p_idTramite: {
        type: Number,
        required: true,
      },
      p_tipo: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        cargas: [],
        usuarios: [],
        datoCarga: {},
        titulo: "",
        btnCrear: false,
        btnEditar: false,
        elementosPorPagina: 10,
        datosPaginados: [],
        paginaActual: 1,
        modalWindow: true,
        tramites: [],
        p_idPerfil: 0,
        estiloImagen: {
          width: "200px",
          height: "200px",
        },
        usuarioSeleccionado: null,
        mostrarBloque01: true,
        mostrarBloque02: true,
        mostrarBloque03: true,
        mostrarBloque04: true,
      };
    },
computed: {
  botones() {
    return (
      (this.p_tipo === 'med' && this.cargas.fechaFinAud != null) ||
      (this.p_tipo === 'doc' && this.cargas.fechaFinDoc != null)
    );
  }
},
    mounted() {
      this.p_idPerfil = window.sessionStorage.getItem("idPerfil");
      this.p_idUsuario = window.sessionStorage.getItem("idUsuario");

      this.getDataPaginaTodos(this.paginaActual);
      this.cargarUsuarios();
    },
    methods: {
      mostrarOcultarBloque01() {
        this.mostrarBloque01 = !this.mostrarBloque01;
      },
      mostrarOcultarBloque02() {
        this.mostrarBloque02 = !this.mostrarBloque02;
      },
      mostrarOcultarBloque03() {
        this.mostrarBloque03 = !this.mostrarBloque03;
      },
      mostrarOcultarBloque04() {
        this.mostrarBloque04 = !this.mostrarBloque04;
      },
      getFormattedDate(date) {
        return dateFormat.getFormattedDate(date);
      },
      totalPaginas() {
        return Math.ceil(this.cargas.length / this.elementosPorPagina);
      },
      detalleSemanaTitle(desde, hasta) {
        return `Ver detalle de la semana ${desde} - ${hasta}`;
      },
      getDataPaginaTodos(noPagina) {
        api.get("/vwcargaext/tramite-tienearchivos/" +
              this.p_idTramite
          )
          .then((response) => {
            this.cargas = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.cargas.slice(ini, fin);
          });
      },
      getPreviousPage() {
        if (this.paginaActual > 1) {
          this.paginaActual--;
        }
        this.getDataPagina(this.paginaActual);
      },
      getNextPage() {
        if (this.paginaActual < this.totalPaginas()) {
          this.paginaActual++;
        }
        this.getDataPagina(this.paginaActual);
      },
      isActive(noPagina) {
        return noPagina == this.paginaActual ? "active" : "";
      },
      abrirModalEditar(idCarga, desde, hasta) {
        this.modalWindow = true;
        if (idCarga != null) {
          api.get("/vwcargaext/carga/" + idCarga)
            .then((resp) => {
              this.datoCarga = resp.data;
            });
        }
        $("#ventanaModal").modal("show");
        this.titulo =
          "Detalle semana " +
          this.getFormattedDate(desde) +
          " - " +
          this.getFormattedDate(hasta);
        this.btnCrear = false;
        this.btnEditar = true;
      },
      abrirEditar(idCarga) {
        if (idCarga != null) {
          this.$router.push("/cargamd/" + idCarga);
        }
      },
      async cargarUsuarios() {
        try {
          const idPerfil = this.p_tipo === "med" ? 18 : 20;
          const idEmpresa = window.sessionStorage.getItem("idEmpresa");
          const response = await api.get(`/vwusuarios/empresa-perfil/${idEmpresa}/${idPerfil}`);
          this.usuarios = response.data;
        } catch (error) {
          console.error("Error cargando usuarios:", error.message || error);
        }
      },
      async actualizarUsuario(idCarga, tipo) {
        if (this.usuarioSeleccionado !== null) {
          try {
            // Obtener los datos de carga (suponiendo que 'datosCarga' contiene la info actual)
            const carga = this.cargas.find((item) => item.idCarga === idCarga);
            const idUsuarioAsignado = tipo === "med" ? carga.idUsuarioMed : carga.idUsuarioDoc;
	
            if (!carga) {
              console.error("Carga no encontrada.");
              return;
            }
            var fechaActual = new Date();
            // Construir objeto CargaDto con los datos actuales
            const cargaDto = {
              idCarga: carga.idCarga,
              idTramite: carga.idTramite,
              idUsuario: carga.idUsuario,
              idSemana: carga.idSemana,
              idUsrSupMed:
                tipo === "med"
                  ? window.sessionStorage.getItem("idUsuario")
                  : carga.idUsrSupMed,
              idUsrSupDoc:
                tipo === "doc"
                  ? window.sessionStorage.getItem("idUsuario")
                  : carga.idUsrSupDoc,
              idUsuarioMed:
                tipo === "med" ? this.usuarioSeleccionado : carga.idUsuarioMed,
              idUsuarioDoc:
                tipo === "doc" ? this.usuarioSeleccionado : carga.idUsuarioDoc,
              tipo: carga.tipo,
              tipoCarga: carga.tipoCarga,
              fechaReg: carga.fechaReg,
              fechaDesde: carga.fechaDesde,
              fechaHasta: carga.fechaHasta,
              fechaAsigAud: tipo === "med" ? fechaActual : carga.fechaAsigAud,
              fechaAsigDoc: tipo === "doc" ? fechaActual : carga.fechaAsigDoc,
              fechaIniCarga: carga.fechaIniCarga,
              fechaFinCarga: carga.fechaFinCarga,
              nombreArchivo: carga.nombreArchivo,
              tamanioArchivo: carga.tamanioArchivo,
              numeroRegistros: carga.numeroRegistros,
              numeroRegVal: carga.numeroRegVal,
              fechaCreacion: carga.fechaCreacion,
              fechaActualizacion: carga.fechaActualizacion,
              obs: carga.obs,
              tieneErrores: carga.tieneErrores,
              tienePlanillas: carga.tienePlanillas,
              tieneArchivos: carga.tieneArchivos,
              estado: carga.estado,
            };

            let url = tipo === "med"
              ? "/cargas/asignar-auditoria-medica"
              : "/cargas/asignar-gestion-documental";

            // Solo agrega el parámetro si tiene valor
            if (idUsuarioAsignado != null) {
              url += `?idUsuarioAsignado=${idUsuarioAsignado}`;
            }

            // Llamada al backend con cargaDto como body
            await api.post(url, cargaDto);

/*
            const urlAM = "/cargas/asignar-auditoria-medica?idUsuarioAsignado="+idUsuarioAsignado;
            const urlGD = "/cargas/asignar-gestion-documental?idUsuarioAsignado="+idUsuarioAsignado;

            // Llamada al backend
            const response = await api.post(
              tipo === "med" ? urlAM : urlGD,
              cargaDto
            );
*/
			
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text:
                (tipo === "med"
                  ? "Médico Auditor"
                  : "Analista de Gestión Documental") +
                " asignado correctamente.",
            });
            this.getDataPaginaTodos(1);
          } catch (error) {
            console.error("Error al actualizar usuario:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Hubo un error al actualizar el usuario.",
            });
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Advertencia",
            text: "Por favor, seleccione un usuario.",
          });
        }
      },
      abrirNovedades(idTramite, idCarga) {
        if (idTramite != null) {
          this.$router.push(`/cargaplanillanovedades/${idTramite}/${idCarga}`);
        }
      },
      abrirReporte(tipo, idCarga, tipoUsuario) {
        const url = `${config.apiBaseUrl}/reportes/pdf/${tipo}/${this.p_idTramite}?identificador02=${idCarga}&tipo=${tipoUsuario}`;
        window.open(url, "_blank");
      },
      obsAuditoriaMedicaSemanaPDF(idCarga) {
        this.abrirReporte(2, idCarga, 'M');
      },
      obsGestionDocumentalSemanaPDF(idCarga) {
        this.abrirReporte(2, idCarga, 'D');
      },
      async enviarObservaciones(tipo, idCarga) {
        try {
          Swal.fire({
            title: "Procesando...",
            text: "Por favor, espera mientras se genera el reporte.",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading(); // Muestra el indicador de carga
            },
          });
          // Enviar correo
          const response = await api.post(
              '/vwtramites/sendObservaciones', null, {
                  params: {
                      tipo: tipo,
                      idTramite: this.p_idTramite,
                      idUsuario: this.p_idUsuario,
                      idCarga: idCarga,
                  }
              }
          );
          Swal.close();
          if (response.status === 200) {
            Swal.fire(
              "Éxito",
              "El correo se envió correctamente con el documento adjunto.",
              "success"
            );
          }
        } catch (error) {
          // Captura y muestra los errores en la consola
          if (error.response) {
            // La solicitud fue realizada y el servidor respondió con un código de estado
            // que no está en el rango de 2xx
            console.log("Error de respuesta:", error.response);
          } else if (error.request) {
            // La solicitud fue hecha pero no se recibió respuesta
            console.log("Error de solicitud:", error.request);
          } else {
            // Algo sucedió al configurar la solicitud
            console.log(
              "Error en la configuración de la solicitud:",
              error.message
            );
          }

          Swal.fire(
            "Error",
            "Ocurrió un problema al procesar la solicitud. Intenta de nuevo.",
            "error"
          );
        }
      },
    },
  };
</script>
<style scoped>
  .text-right {
    text-align: right;
  }
</style>
